"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});


// eslint-disable-next-line import/prefer-default-export
var isArraysEqualShallow = exports.isArraysEqualShallow = function isArraysEqualShallow(array, other) {
    if (array === other) {
        return true;
    }
    if (!Array.isArray(array) || !Array.isArray(other) || array.length !== other.length) {
        return false;
    }

    var result = true;
    var arrLength = array.length;
    for (var index = 0; index < arrLength; index += 1) {
        if (array[index] !== other[index]) {
            result = false;
            break;
        }
    }
    return result;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-accessible-accordion/dist/utils/index.js
// module id = 1230
// module chunks = 2